import { createSelector } from "reselect";
import get from "lodash/get";
import Logo from "assets/images/singpass_logo.png";
import { selectedNumberSelector, selectedNumberTypeSelector } from "./numbers";
import { portInNumberSelector } from "./index";

export const liquidOcrDataDomain = state =>
  get(state.api, "liquidOcrData.data", {});

export const ekycValidationFailure = state =>
  get(state.api, "ekycValidation.data", false);

// ***************************************************************
// ****************** ekyc selectors *****************************
// ***************************************************************

export const liquidOcrDataSelector = createSelector(
  liquidOcrDataDomain,
  liquidOcrData => liquidOcrData
);

export const ekycValidationSelector = createSelector(
  ekycValidationFailure,
  ekycValidation => ekycValidation
);

// ***************************************************************
// ********************** ekyc makeSelect ************************
// ***************************************************************

export const makeSelectLiquidOcrData = () => liquidOcrDataSelector;

export const makeSelectEKYCMessageData = () =>
  createSelector(
    selectedNumberTypeSelector,
    portInNumberSelector,
    selectedNumberSelector,
    (selectedNumberType, portInNumber, selectedNumber) => {
      return {
        selectedNumber: get(selectedNumberType, "isPortIn", false)
          ? portInNumber || ""
          : selectedNumber?.number || "",
        logo: Logo
      };
    }
  );

export const makeSelectEkycValidation = () => ekycValidationSelector;
